import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    langs: localStorage.getItem('lang') || 'en'
  },
  mutations: {
    setLangs(state, langs) {
      state.langs = langs;
    }
  },
  actions: {},
  modules: {},
});
